import { TQTabView } from 'components/TQDataGrid/utils/grid-types';
import { useTerritoryViewContext } from 'contexts/TerritoryViewContext';
import { useNavigationData } from 'hooks/useNavigationData';
import { useDataObjectSchema } from 'hooks/useDataObjectSchema';
import type { StringifiedUUID } from 'types';

type UseGetDataObjectSchemasOptions = {
  // territory view ID override
  territoryViewId?: StringifiedUUID | null;
  includeExportable?: boolean;
};

export function useGetDataObjectSchemas(options: UseGetDataObjectSchemasOptions = {}) {
  const { territoryViewId: territoryViewIdOverride, includeExportable = false } = options;
  const { tqModel } = useNavigationData();
  const { activeNode, selectedTerritoryViewId } = useTerritoryViewContext();

  // Use override if provided, otherwise fall back to context
  const territoryViewId = territoryViewIdOverride !== undefined ? territoryViewIdOverride : selectedTerritoryViewId;

  const {
    isLoading: isTerritoriesSchemaLoading,
    dataObjectSchema: territoriesSchema,
    invalidateQuery: invalidateTerritoriesSchemaQuery,
  } = useDataObjectSchema(
    TQTabView.TERRITORIES,
    { tqModelId: tqModel?.id, territoryViewId, dataObjectId: activeNode?.id as string },
    { includeExportable },
  );

  const {
    isLoading: isAccountsSchemaLoading,
    dataObjectSchema: accountsSchema,
    invalidateQuery: invalidateAccountsSchemaQuery,
  } = useDataObjectSchema(
    TQTabView.ACCOUNTS,
    { tqModelId: tqModel?.id, territoryViewId, dataObjectId: activeNode?.id as string },
    { includeExportable },
  );

  return {
    isTerritoriesSchemaLoading,
    isAccountsSchemaLoading,
    accountsSchema,
    territoriesSchema,
    invalidateTerritoriesSchemaQuery,
    invalidateAccountsSchemaQuery,
  };
}
